import * as PIXI from 'pixi.js';
import { LayoutContainer } from '@pixi/layout/components'; // eslint-disable-line
import { APP_WIDTH } from '../../utils';

import TappableTextureButton from './TappableTextureButton';

const BUTTON_WIDTH = 228;
const BUTTON_HEIGHT = 234;
const HORIZONTAL_INSET = 120;
const VERTICAL_PADDING = 80;
const SELECTED_TEXT_COLOR = '#fdeca3';
const TEXT_COLOR = '#ffffff';
const BADGE_WIDTH = 120;
const BADGE_HEIGHT = 54;
const BADGE_RIGHT = 240;
const BADGE_CENTER_Y = 42;

export const BOTTOM_BAR_HEIGHT = BUTTON_HEIGHT + VERTICAL_PADDING * 2;

export default class BottomBar extends LayoutContainer {
    static async loadAssets() {
        await PIXI.Assets.load([
            { src: '/assets/bottom_bar/main_icon.png', alias: 'bottomBarMainIcon' },
            { src: '/assets/bottom_bar/coll_icon.png', alias: 'bottomBarCollIcon' },
            { src: '/assets/bottom_bar/shop_icon.png', alias: 'bottomBarShopIcon' },
        ]);
    }

    constructor({ width = APP_WIDTH, selected, onCollectionTap, onMainTap, onShopTap, shopBadgeVisible = false } = {}) {
        super();

        this.label = 'bottomBar';
        this.selected = selected;
        this.onCollectionTap = onCollectionTap;
        this.onMainTap = onMainTap;
        this.onShopTap = onShopTap;

        this.layout = {
            width,
            height: BOTTOM_BAR_HEIGHT,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: HORIZONTAL_INSET,
            paddingRight: HORIZONTAL_INSET,
        };

        this.buildBackground(width);
        this.collectionButton = this.buildButton({
            name: 'collection',
            textureAlias: 'bottomBarCollIcon',
            text: 'CARDS',
            onTap: () => this.onCollectionTap?.(),
        });
        this.mainButton = this.buildButton({
            name: 'main',
            textureAlias: 'bottomBarMainIcon',
            text: 'MAIN',
            onTap: () => this.onMainTap?.(),
        });
        this.shopButton = this.buildButton({
            name: 'shop',
            textureAlias: 'bottomBarShopIcon',
            text: 'SHOP',
            onTap: () => this.onShopTap?.(),
        });
        this.shopBadge = this.buildBadge(this.shopButton);
        this.setShopBadgeVisible(shopBadgeVisible);
    }

    setShopBadgeVisible(visible) {
        this.shopBadge.visible = Boolean(visible);
    }

    buildBadge(button) {
        const fill = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0 },
            end: { x: 0, y: 1 },
            colorStops: [
                { offset: 0, color: '#6aa846' },
                { offset: 1, color: '#2c5729' },
            ],
        });

        const badge = new PIXI.Container();
        badge.label = `${button.label}Badge`;
        badge.eventMode = 'none';
        badge.interactiveChildren = false;

        const background = new PIXI.Graphics();
        background.roundRect(0, 0, BADGE_WIDTH, BADGE_HEIGHT, BADGE_HEIGHT / 2);
        background.fill(fill);
        background.stroke({ color: '#76ae4d', width: 5 });
        badge.addChild(background);

        const label = new PIXI.Text({
            text: 'FREE',
            style: {
                fontFamily: 'Open Sans',
                fontSize: 30,
                fontWeight: 'bold',
                fill: '#ffffff',
                letterSpacing: 1,
            },
        });
        label.anchor.set(0.5);
        label.x = BADGE_WIDTH / 2;
        label.y = BADGE_HEIGHT / 2;
        badge.addChild(label);

        badge.x = BADGE_RIGHT - BADGE_WIDTH;
        badge.y = BADGE_CENTER_Y - BADGE_HEIGHT / 2;
        button.addChild(badge);
        return badge;
    }

    buildBackground(width) {
        const background = new PIXI.Graphics();
        background.label = 'bottomBarBackground';
        background.rect(0, BOTTOM_BAR_HEIGHT / 2 + 10, width, BOTTOM_BAR_HEIGHT);
        background.fill('black');
        background.moveTo(0, BOTTOM_BAR_HEIGHT / 2 + 10);
        background.lineTo(width, BOTTOM_BAR_HEIGHT / 2 + 10);
        background.stroke({ color: '#bf9048', width: 7 });
        this.addChild(background);
    }

    buildButton({ name, textureAlias, text, onTap }) {
        const buttonContainer = new LayoutContainer();
        buttonContainer.label = `${name}ButtonContainer`;
        buttonContainer.layout = {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        };

        const button = new TappableTextureButton({
            texture: PIXI.Assets.get(textureAlias),
            width: BUTTON_WIDTH,
            height: BUTTON_HEIGHT,
        });
        button.label = `${name}Button`;
        button.onButtonTap = () => {
            onTap?.();
        };

        const buttonText = new PIXI.Text({
            text,
            style: {
                fontFamily: 'Caladea',
                fontSize: 45,
                fill: name === this.selected ? SELECTED_TEXT_COLOR : TEXT_COLOR,
                fontWeight: 'bold',
                letterSpacing: 1,
            },
        });
        buttonText.label = `${name}ButtonText`;
        buttonText.anchor = { x: 0.5, y: 0 };
        buttonText.y = BUTTON_HEIGHT;
        buttonText.x = BUTTON_WIDTH / 2;

        buttonContainer.addChild(button);
        buttonContainer.addChild(buttonText);
        this.addChild(buttonContainer);

        return button;
    }
}
